import { render } from "./SmsRecharge.vue?vue&type=template&id=2aac455b"
import script from "./SmsRecharge.vue?vue&type=script&lang=js"
export * from "./SmsRecharge.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Sources\\Repos\\TaskApi\\TaskApp.VueCore\\clientTaskApp\\clientTaskApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__